import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  CreateUserQualificationRow,
  UpdateUserQualificationRow,
  UserQualificationRow,
} from "./userQualification.type";

export const getUserQualifications = async (
  userId?: string
): Promise<UserQualificationRow[]> => {
  const slug =
    ApiEndpoints.userQualification + (userId ? `/user/${userId}` : "");
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<UserQualificationRow[]>(slug, options);
};

export const createUserQualification = async (
  qualification: CreateUserQualificationRow
): Promise<UserQualificationRow> => {
  const slug = ApiEndpoints.userQualification + "/";
  const options = await setHeaderOptions({
    method: "POST",
    body: qualification,
  });
  return fetchData<UserQualificationRow>(slug, options);
};

export const updateUserQualification = async (
  qualification: UpdateUserQualificationRow
): Promise<UserQualificationRow> => {
  const slug = ApiEndpoints.userQualification + "/";
  const options = await setHeaderOptions({
    method: "PUT",
    body: qualification,
  });
  return fetchData<UserQualificationRow>(slug, options);
};
